import React from 'react';
import GeneralChart from '@/components/seo/GeneralChart';
import { JobTitleContext } from '@/context/create-context';

const SalaryIndustry = (props: {
  id: string;
  industryData: Record<string, any>;
}) => {
  const { id, industryData } = props;
  const industryTypeData = industryData?.['行业类型与潜力'] || [];
  const industryEffectContent = industryData?.['影响因素'];

  const { isJobTitleCity } = React.useContext(JobTitleContext);

  return (
    <GeneralChart
      id={id}
      title="影响薪资的核心维度3：所在行业"
      tip={industryData['tip']}
    >
      <p className="mb-2">
        {industryData['一句话总结']?.[
          isJobTitleCity ? '城市趋势' : '全国趋势'
        ] || ''}
      </p>
      {!!industryTypeData.length && (
        <div className="my-6">
          <table className="w-full table-fixed text-left text-sm">
            <thead className="bg-web-grey-300 border-b border-web-tertiary">
              <tr>
                <th className="py-2 pl-3">行业梯队</th>
                <th className="py-2 px-3">代表行业</th>
                <th className="py-2 px-3">高薪原因</th>
              </tr>
            </thead>
            <tbody className="text-xs">
              {industryTypeData.map(
                (item: Record<string, string>, index: number) => (
                  <tr key={index} className="border-b border-web-tertiary">
                    <td className="py-2 pl-3">{item['行业梯队'] || ''}</td>
                    <td className="py-2 px-3">{item['代表行业'] || ''}</td>
                    <td className="py-2 px-3">{item['薪酬原因'] || ''}</td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      )}
      {industryEffectContent && (
        <>
          <p className="font-semibold mb-2">影响因素</p>
          <p>{industryEffectContent?.['城市概述'] || ''}</p>
          <ul className="list-inside !ml-2 my-2">
            {(industryEffectContent?.['因素列表'] || []).map(
              (item: string, index: number) => (
                <li key={index}>{item}</li>
              ),
            )}
          </ul>
        </>
      )}
    </GeneralChart>
  );
};

export default SalaryIndustry;
